import { useRequest } from 'domain/core/hooks/useRequest';
import { ApiMethodsEnum } from 'infrastructure/enums/ApiMethodsEnum';

export const APPLICANTS_PER_PAGE = 10;

export const useGetApplicants = () => {
  const { data, isLoading, error, send } = useRequest({
    method: ApiMethodsEnum.Get,
    sendOnStart: false,
  });

  const getAllApplicants = (
    jobPostId: any,
    page: number = 1,
    limit: number = APPLICANTS_PER_PAGE
  ) => {
    send({}, `/api/v1/application/forRecruiter/${jobPostId}?limit=${limit}&page=${page}`).then();
  };

  const getAppliedApplicants = (
    jobPostId: any,
    page: number = 1,
    limit: number = APPLICANTS_PER_PAGE
  ) => {
    send(
      {},
      `/api/v1/application/forRecruiter/${jobPostId}?limit=${limit}&page=${page}&applicationType=APPLY`
    ).then();
  };

  const getInvitedApplicants = (
    jobPostId: any,
    page: number = 1,
    limit: number = APPLICANTS_PER_PAGE
  ) => {
    send(
      {},
      `/api/v1/application/forRecruiter/${jobPostId}?limit=${limit}&page=${page}&applicationType=INVITE`
    ).then();
  };

  return {
    getAllApplicants,
    getAppliedApplicants,
    getInvitedApplicants,
    data,
    isLoading,
    error,
  };
};
